import { CurrentContextService, DataSynchListService, EventsStorageInterface, NamedBindings, SynchListElement, UserServiceInterface } from "@dandelion/core";
import { inject } from "inversify";


export class DataSynchListServiceForProsafe extends DataSynchListService {

    constructor(
        @inject(NamedBindings.StorageForSynchEvents)
        protected stackOfEventsStorage: EventsStorageInterface,
        @inject(NamedBindings.CurrentContextService)
        protected currentContextService: CurrentContextService,
        @inject(NamedBindings.UserService) protected userService: UserServiceInterface
    ) {
        super(stackOfEventsStorage, currentContextService, userService);
    }
    protected moveCaseToPermanentlyDeleteList(caseID: string, listToBeRemovedFrom: Array<SynchListElement>) {
        const caseToBeMoved = listToBeRemovedFrom.find((xCase) => xCase.caseID === caseID);
        if (caseToBeMoved) {
            DataSynchListService.removeCaseFromList(listToBeRemovedFrom, caseID);
        }
        if (!this.permanentlyDeletedSynchList.includes(caseID)) {
            this.permanentlyDeletedSynchList.push(caseID);
        }
    }
}